<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn color="success" v-on="on">Apply</v-btn>
    </template>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>
          <span class="headline">Apply</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Legal first name*"
                  :rules="[v => !!v || 'First name is required']"
                  v-model="form.FirstName"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Other names"
                  v-model="form.OtherNames"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Legal last name*"
                  required
                  :rules="[v => !!v || 'Last name is required']"
                  v-model="form.Surname"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  prepend-icon="mail"
                  label="Email*"
                  :rules="[v => !!v || 'Email is required']"
                  v-model="form.Email"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  label="CV or other files*"
                  :rules="fileRules"
                  show-size
                  counter
                  multiple
                  required
                  v-model="files"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">
                      {{ text }}
                    </v-chip>
                  </template></v-file-input
                >
              </v-col>
              <v-col cols="12">
                <v-textarea
                  prepend-icon="person"
                  label="More about you"
                  v-model="form.About"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="understand"
                  :rules="[v => !!v || 'Confirmation is required']"
                  required
                >
                  <div class="body-2" slot="label">
                    {{ confirmation }}
                  </div>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="validate">Apply</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template> 

<script>
export default {
  fiery: true,
  props: ["loading"],
  data: function() {
    return {
      dialog: false,
      valid: false,
      understand: false,
      confirmation:
        "I understand that I am applying for this position, I believe that I meet the requirements for this position and I have provided all the required information to apply.",
      fileRules: [
        f => f.length > 0 || "At least 1 document is required",
        f => !this.hasDupes(f) || "Files cannot have the same name"
      ],
      form: {
        user: this.$store.state.user.Login,
        FirstName: this.$store.state.user.FirstName,
        OtherNames: "",
        Surname: this.$store.state.user.Surname,
        Email: this.$store.state.user.Email,
        About: "",
        fav: false,
        seen: false,
        rejected: false,
        nextStep: false
      },
      files: []
    };
  },
  methods: {
    validate: function() {
      if (this.$refs.form.validate()) {
        console.log(this.hasDupes(this.files));
        this.$emit("apply", this.form, this.files);
      }
    },
    hasDupes: function(files) {
      const seen = new Set();
      return (
        files.filter(file => {
          const duplicate = seen.has(file.name);
          seen.add(file.name);
          return !duplicate;
        }).length != files.length
      );
    }
  },

  mounted() {}
};
</script>